module.exports = ".calendar .ui-datepicker{\r\n  width: 100% !important;\r\n}\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/page/policy/holiday_management.css
// module id = ./src/app/page/policy/holiday_management.css
// module chunks = main